import axiosClient from "./axiosClients";
import queryString from "query-string";

const uri = "/carts";

class CartApi {

  paginate = (size = 0, index = 1, keySort = "") => {
    const params = queryString.stringify({
      size,
      index,
      keySort,
    });
    const url = `${uri}/pagination?${params}`;
    return axiosClient.get(url);
  };

  toggleStatusPayment = (id) => {
    const url = `${uri}/toggle-status-payment/${id}`;
    return axiosClient.patch(url);
  };
}
const cartApi = new CartApi();
export default cartApi;
